import { ReactElement, useCallback, useMemo } from 'react';
import moment from 'moment-timezone';

import {
  useDownloadReportRoutes,
  useDownloadReportItems,
  useDownloadReportItemTasks,
} from '~hooks/useReports';
import { formatterDate } from '~utils/formatter';

import ReportsDownloadSectionWrapperForm from '../../Wrappers/Form';
import { ReportsDownloadSectionWrapperFormSubmitHandler } from '../../Wrappers/Form/types';

const ReportsDownloadSectionVariantBySelector = (): ReactElement => {
  const {
    loading: loadingReportRoutes,
    error: errorReportRoutes,
    onDownload: onDownloadReportRoutes,
  } = useDownloadReportRoutes();
  const {
    loading: loadingReportItems,
    error: errorReportItems,
    onDownload: onDownloadReportItems,
  } = useDownloadReportItems();
  const {
    loading: loadingReportItemTasks,
    error: errorReportItemTasks,
    onDownload: onDownloadReportItemTasks,
  } = useDownloadReportItemTasks();

  const onSubmit = useCallback<ReportsDownloadSectionWrapperFormSubmitHandler>(
    async (formValues) => {
      const baseBody = {
        dateTimeFrom: formatterDate(formValues.dateFrom, {
          format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
          parseToUtc: true,
        }),
        dateTimeTo: formatterDate(formValues.dateTo, {
          format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
          parseToUtc: true,
        }),
      };

      if (formValues.type === 'routes') {
        await onDownloadReportRoutes(baseBody);
      }

      if (formValues.type === 'items') {
        await onDownloadReportItems({ ...baseBody, emailDestinatary: '' });
      }

      if (formValues.type === 'itemTasks') {
        await onDownloadReportItemTasks({ ...baseBody, emailDestinatary: '' });
      }
    },
    [onDownloadReportRoutes, onDownloadReportItems, onDownloadReportItemTasks],
  );

  const loading = useMemo(
    () => loadingReportRoutes || loadingReportItems || loadingReportItemTasks,
    [loadingReportRoutes, loadingReportItems, loadingReportItemTasks],
  );

  const error = useMemo(
    () =>
      Boolean(errorReportRoutes) ||
      Boolean(errorReportItems) ||
      Boolean(errorReportItemTasks),
    [errorReportRoutes, errorReportItems, errorReportItemTasks],
  );

  return (
    <ReportsDownloadSectionWrapperForm
      onSubmit={onSubmit}
      loadingSubmit={loading}
      errorSubmit={error}
      withSelectorType
      gutters={false}
    />
  );
};

export default ReportsDownloadSectionVariantBySelector;
